import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { RoleListComponent } from './components/role-list/role-list.component';
import { AddEditRoleComponent } from './components/add-edit-role/add-edit-role.component';
import { RoleDetailViewComponent } from './components/role-detail-view/role-detail-view.component';

const routes: Routes = [
  { path: 'role-list', component: RoleListComponent},
  { path: '**', redirectTo: 'role-list' },
]

@NgModule({
  declarations: [
    RoleListComponent,
    AddEditRoleComponent,
    RoleDetailViewComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
  ]
})
export class RoleManagementModule { }
